import { render, staticRenderFns } from "./EntityIcon.vue?vue&type=template&id=457ece16&scoped=true&"
import script from "./EntityIcon.vue?vue&type=script&lang=js&"
export * from "./EntityIcon.vue?vue&type=script&lang=js&"
import style0 from "./EntityIcon.vue?vue&type=style&index=0&id=457ece16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ece16",
  null
  
)

export default component.exports